module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099G68NX5.fa4ce30b.jpg";